import { configureStore } from '@reduxjs/toolkit';
import filterReducer from './filterSlice';
import catalogTableReducer from './catalogTableSlice';
import integrationsExplorerReducer from './integrationsExplorerSlice';
import serviceOwnersReducer from './serviceOwnersSlice';

export const store = configureStore({
  reducer: {
    filters: filterReducer,
    serviceOwners: serviceOwnersReducer,
    catalogTable: catalogTableReducer,
    integrationsExplorer: integrationsExplorerReducer,
    serviceOwners: serviceOwnersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;